/*!
 * Bombka Wspomnień – product form
 * Variant switching, quantity, Ajax add-to-cart and "Kup teraz".
 * All prices and availability come from Shopify product JSON.
 */
(function () {
  'use strict';

  var BW = window.BW || {};
  var S = BW.strings || {};
  var R = BW.routes || {};

  function money(cents) {
    return window.BWCart ? window.BWCart.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  function setup(form) {
    if (form.__bwReady) return;
    form.__bwReady = true;

    var scope = form.getAttribute('data-bw-product-form');
    var root = form.closest('[data-bw-product-root]') || document;
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-bw-variants]').textContent); } catch (e) {}

    var select = form.querySelector('[data-bw-variant-select]');
    var qty = form.querySelector('input[name="quantity"]');
    var buyBtn = form.querySelector('[data-bw-buy-now]');
    var addBtn = form.querySelector('[data-bw-add]');
    var errBox = form.querySelector('[data-bw-error]');
    var lastSubmitter = null;

    function currentVariant() {
      var id = select ? parseInt(select.value, 10) : parseInt((form.querySelector('[name="id"]') || {}).value, 10);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg || '';
      errBox.hidden = !msg;
    }

    function updatePrice(v) {
      if (!v) return;
      var price = document.querySelectorAll('[data-bw-price="' + scope + '"]');
      for (var i = 0; i < price.length; i++) {
        var box = price[i];
        var pct = parseInt(box.getAttribute('data-percent'), 10) || 0;
        var cur = box.querySelector('[data-bw-price-current]');
        var cmp = box.querySelector('[data-bw-price-compare]');
        var cmpVal = box.querySelector('[data-bw-price-compare-value]');
        var disc = box.querySelector('[data-bw-price-discounted]');
        if (cur) cur.textContent = money(v.price);
        if (cmp) {
          var show = v.compare_at_price && v.compare_at_price > v.price;
          cmp.hidden = !show;
          box.classList.toggle('has-compare', !!show);
          if (show && cmpVal) cmpVal.textContent = money(v.compare_at_price);
        }
        if (disc) disc.textContent = money(Math.floor(v.price * (100 - pct) / 100));
      }
      var mirrors = root.querySelectorAll('[data-bw-price-current-mirror]');
      for (var m = 0; m < mirrors.length; m++) {
        mirrors[m].textContent = money(v.price);
        if (mirrors[m].parentNode) mirrors[m].parentNode.classList.toggle('has-compare', !!(v.compare_at_price && v.compare_at_price > v.price));
      }
      var dmirrors = root.querySelectorAll('[data-bw-price-discounted-mirror]');
      var pctAll = (BW.offer && BW.offer.percent) || 0;
      for (var dm = 0; dm < dmirrors.length; dm++) dmirrors[dm].textContent = money(Math.floor(v.price * (100 - pctAll) / 100));

      var label = v.available ? null : (S.soldOut || '');
      [buyBtn, addBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        var l = b.querySelector('[data-bw-buy-label], [data-bw-add-label]');
        if (l) {
          if (!l.__orig) l.__orig = l.textContent;
          l.textContent = label || l.__orig;
        }
      });
      var trig = document.querySelectorAll('[data-bw-trigger-buy="' + form.id + '"]');
      for (var t = 0; t < trig.length; t++) trig[t].disabled = !v.available;
    }

    if (select) {
      select.addEventListener('change', function () {
        var v = currentVariant();
        updatePrice(v);
        showError('');
        if (v && v.featured_media) {
          document.dispatchEvent(new CustomEvent('bw:variant-media', { detail: { mediaId: v.featured_media.id } }));
        }
      });
    }

    form.addEventListener('click', function (e) {
      var q = e.target.closest('[data-bw-qty]');
      if (q && qty) {
        var next = (parseInt(qty.value, 10) || 1) + parseInt(q.getAttribute('data-bw-qty'), 10);
        qty.value = Math.min(99, Math.max(1, next));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var b = e.target.closest('button[type="submit"]');
      if (b) lastSubmitter = b;
    });

    if (qty) {
      qty.addEventListener('blur', function () {
        var n = parseInt(qty.value, 10);
        qty.value = isNaN(n) || n < 1 ? 1 : Math.min(99, n);
      });
    }

    function add(buyNow) {
      var btn = buyNow ? buyBtn : addBtn;
      if (!btn || btn.disabled || form.classList.contains('is-loading')) return;
      showError('');
      form.classList.add('is-loading');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');

      fetch((R.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            var err = new Error('add'); err.status = res.status; throw err;
          }
          return data;
        });
      }).then(function () {
        if (buyNow) {
          window.location.href = window.BWCart ? window.BWCart.checkoutUrl() : '/checkout';
          return;
        }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        if (window.BWCart) {
          window.BWCart.open();
          return window.BWCart.refresh();
        }
        window.location.href = R.cart || '/cart';
      }).catch(function (err) {
        showError(err && err.status === 422 ? S.stockError : S.addError);
      }).then(function () {
        if (!buyNow) {
          form.classList.remove('is-loading');
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      });

      // Safety: release the loading state if the redirect is blocked.
      if (buyNow) setTimeout(function () {
        form.classList.remove('is-loading');
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }, 8000);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitter = e.submitter || lastSubmitter;
      add(!!(submitter && submitter.hasAttribute('data-bw-buy-now')));
    });

    form.__bwAdd = add;
  }

  function init() {
    var forms = document.querySelectorAll('form[data-bw-product-form]');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bw-trigger-buy]');
      if (!t) return;
      var f = document.getElementById(t.getAttribute('data-bw-trigger-buy'));
      if (f && f.__bwAdd) f.__bwAdd(true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
